document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Header solid-on-scroll ---------------- */
  var header = document.querySelector('[data-ma-header]');
  function getScrollThreshold() {
    // Header jab tak hero section ka ~85% scroll na ho jaye tab tak transparent rahega
    var hero = document.querySelector('.ma-hero');
    if (hero) {
      return hero.getBoundingClientRect().height * 0.85;
    }
    return window.innerHeight * 0.85; // fallback agar hero na mile
  }
  function toggleHeaderSolid() {
    if (!header) return;
    if (window.scrollY > getScrollThreshold()) {
      header.classList.add('is-solid');
    } else if (header.dataset.forceSolid !== 'true') {
      header.classList.remove('is-solid');
    }
  }
  var headerRafPending = false;
  function onScrollThrottled() {
    if (headerRafPending) return;
    headerRafPending = true;
    requestAnimationFrame(function () {
      toggleHeaderSolid();
      headerRafPending = false;
    });
  }
  window.addEventListener('scroll', onScrollThrottled, { passive: true });
  toggleHeaderSolid();

  /* ---------------- Overlay helper ---------------- */
  var overlay = document.getElementById('ma-cart-overlay');
  function showOverlay() { if (overlay) { overlay.hidden = false; requestAnimationFrame(function(){ overlay.classList.add('is-visible'); }); } }
  function hideOverlay() { if (overlay) { overlay.classList.remove('is-visible'); setTimeout(function(){ overlay.hidden = true; }, 300); } }
  if (overlay) overlay.addEventListener('click', function () { closeAllPanels(); });

  function closeAllPanels() {
    document.querySelectorAll('.ma-mobile-nav, .ma-search-panel, .ma-cart-drawer').forEach(function (p) {
      p.classList.remove('is-open');
      p.classList.remove('ma-mobile-nav--open'); // naya tabbed drawer bhi close ho jaye
    });
    hideOverlay();
  }

  /* ---------------- Mobile nav ----------------
     NOTE: Naye tabbed drawer ka open/close ab header.liquid ke
     inline <script> me #ma-burger / #ma-mobile-nav-close / tab
     switching ke through handle hota hai. Isliye purana burger
     click handler yahan se hata diya gaya hai taaki dono handlers
     conflict na karein (purana 'is-open' class toggle karta tha,
     jo naye '.ma-mobile-nav--open' se match nahi karti thi).
  ---------------------------------------------- */

  /* ---------------- Search panel ---------------- */
  var searchTrigger = document.getElementById('ma-search-trigger');
  var searchPanel = document.getElementById('ma-search-panel');
  var searchClose = document.getElementById('ma-search-close');
  if (searchTrigger && searchPanel) {
    searchTrigger.addEventListener('click', function () {
      searchPanel.classList.add('is-open');
      showOverlay();
      var input = searchPanel.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 300);
    });
  }
  if (searchClose) searchClose.addEventListener('click', closeAllPanels);

  /* ---------------- Cart drawer ---------------- */
  var cartTrigger = document.getElementById('ma-cart-trigger');
  var cartDrawer = document.getElementById('ma-cart-drawer');
  var cartClose = document.getElementById('ma-cart-close');
  if (cartTrigger && cartDrawer) {
    cartTrigger.addEventListener('click', function () {
      cartDrawer.classList.add('is-open');
      showOverlay();
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeAllPanels);

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  /* ---------------- Generic horizontal-scroll arrows ---------------- */
  document.querySelectorAll('[data-ma-arrows]').forEach(function (arrowsWrap) {
    var targetId = arrowsWrap.getAttribute('data-ma-arrows');
    var track = document.getElementById(targetId);
    if (!track) return;
    var prev = arrowsWrap.querySelector('[data-dir="prev"]');
    var next = arrowsWrap.querySelector('[data-dir="next"]');
    var cardWidth = function () {
      var card = track.querySelector(':scope > *');
      return card ? card.getBoundingClientRect().width + 22 : 300;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardWidth() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardWidth() * 2, behavior: 'smooth' }); });
  });

  /* ---------------- Collection tabs ---------------- */
  document.querySelectorAll('[data-ma-tabs]').forEach(function (tabsWrap) {
    var tabs = tabsWrap.querySelectorAll('.ma-tab');
    var groupName = tabsWrap.getAttribute('data-ma-tabs');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panelId = tab.getAttribute('data-panel');
        document.querySelectorAll('[data-ma-panel-group="' + groupName + '"]').forEach(function (panel) {
          panel.style.display = (panel.id === panelId) ? '' : 'none';
        });
      });
    });
  });

  /* ---------------- Product card hover image swap ---------------- */
  document.querySelectorAll('.ma-product-card').forEach(function (card) {
    var imgs = card.querySelectorAll('.ma-card__img--secondary');
    if (!imgs.length) return;
    card.addEventListener('mouseenter', function () { imgs[0].style.opacity = '1'; });
    card.addEventListener('mouseleave', function () { imgs[0].style.opacity = '0'; });
  });

  /* ---------------- Add to cart (AJAX) ---------------- */
  document.querySelectorAll('[data-ma-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartCount(cart.item_count); if (cartDrawer) { cartDrawer.classList.add('is-open'); showOverlay(); } })
        .catch(function (err) { console.error('Cart error:', err); });
    });
  });

  function updateCartCount(count) {
    var el = document.getElementById('ma-bag-count');
    if (el) { el.textContent = count; el.style.display = count > 0 ? 'flex' : 'none'; }
  }

  /* ---------------- Hero video play/pause toggle ---------------- */
  document.querySelectorAll('[data-ma-video-toggle]').forEach(function (btn) {
    var videoId = btn.getAttribute('data-ma-video-toggle');
    var video = document.getElementById(videoId);
    if (!video) return;
    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); btn.classList.remove('is-paused'); }
      else { video.pause(); btn.classList.add('is-paused'); }
    });
  });

});